import Dashboard from "./Dashboard";
export default Dashboard;
export { default as Dashboard } from './Dashboard';